import { Clazz, createModelSchema, list, object, primitive } from 'serializr';

import Deployment from 'types/deployment';
import Pipeline from 'types/pipeline';

/** @deprecated
 * Use {@link OffsetPaginated} instead.
 */
export class PaginatedAPIResponse<TClass> {
  pagination: 'offset';

  data: TClass[];

  current_page: number;
  total_pages: number;
  total_elements: number;
  page_elements: number;

  previous_page: number | null;
  next_page: number | null;

  constructor(
    pagination: 'offset',
    data: TClass[],
    currentPage: number,
    totalPages: number,
    totalElements: number,
    pageElements: number,
    previousPage: number | null,
    nextPage: number | null
  ) {
    this.pagination = pagination;
    this.data = data;
    this.current_page = currentPage;
    this.total_pages = totalPages;
    this.total_elements = totalElements;
    this.page_elements = pageElements;
    this.previous_page = previousPage;
    this.next_page = nextPage;
  }
}

function createPaginatedModelSchema<TClass>(
  paginatedResponseClass: Clazz<PaginatedAPIResponse<TClass>>,
  modelClass: Clazz<TClass>
) {
  if (!modelClass) {
    return;
  }

  createModelSchema(paginatedResponseClass, {
    pagination: primitive(),
    current_page: primitive(),
    total_pages: primitive(),
    total_elements: primitive(),
    page_elements: primitive(),
    previous_page: primitive(),
    next_page: primitive(),
    data: list(object(modelClass)),
  });
}

/** Typed extensions of `PaginatedAPIResponse` for use with serializr. */

export class DeploymentPaginatedAPIResponse extends PaginatedAPIResponse<Deployment> {}
createPaginatedModelSchema(DeploymentPaginatedAPIResponse, Deployment);

export class PipelinePaginatedAPIResponse extends PaginatedAPIResponse<Pipeline> {}
createPaginatedModelSchema(PipelinePaginatedAPIResponse, Pipeline);
